import Login from './Login.container';

export default Login;
